import { Pipe, PipeTransform } from '@angular/core';
import { from, map } from 'rxjs';

import { Airport } from '@app/components/modals/planning-trip-modal/planning-trip-modal.component';

@Pipe({
  name: 'getAirportByLocationCode',
})
export class GetAirportByLocationCodePipe implements PipeTransform {
  transform(locationCode: string) {
    return from(import('static/airports').then((mod) => mod.default as unknown as Airport[])).pipe(
      map((options) => [...options].find((o) => o.locationCode === locationCode)),
    );
  }
}
